import { resetRoutes, setRoutes } from './routesSlice';

export const storeRoutes = (routes) => {
  return setRoutes({ asyncNewRoutes: routes });
};

export const clearRoutes = () => resetRoutes();
